import {
  REGEX_CITY,
  REGEX_COMPANY,
  REGEX_LETTERS_DOTS_AND_COMMAS_ONE_LETTER,
  REGEX_STREET_AND_NUMBER,
} from '../../../constants/form';
import { FieldName } from '../../../enums/address';

const getFieldRegexPattern = (field: string) =>
  new Map<string, RegExp>([
    [FieldName.FirstName, REGEX_LETTERS_DOTS_AND_COMMAS_ONE_LETTER],
    [FieldName.LastName, REGEX_LETTERS_DOTS_AND_COMMAS_ONE_LETTER],
    [FieldName.StreetAndNumber, REGEX_STREET_AND_NUMBER],
    [FieldName.City, REGEX_CITY],
    [FieldName.Company, REGEX_COMPANY],
  ]).get(field);

export const removeFirstAndLastSlashes = (value: string) => value.replace(/^\/|\/$/g, '');

const getAllowedCharacters = (regex: RegExp) => new RegExp(regex).toString().replace(/[/^$]/g, '');

export const getInvalidCharacters = (value: string, regex: RegExp) =>
  [...new Set(value.replace(regex, ''))].join(', ');

export const getInvalidCharErrorDetails = <FieldName extends string = string>(
  field: FieldName,
  value: string
) => {
  const fieldRegexPattern = getFieldRegexPattern(field);

  return (
    fieldRegexPattern &&
    value &&
    getInvalidCharacters(
      value,
      new RegExp(removeFirstAndLastSlashes(getAllowedCharacters(fieldRegexPattern)), 'g')
    )
  );
};
